





























import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import Welcome from '@/components/Home/InsureCareTeams/Welcome.vue';
import CoiWidget from '@/components/Home/InsureCareTeams/CoiWidget.vue';
import ClaimWidget from '@/components/Home/InsureCareTeams/ClaimWidget.vue';
import QuotesWidget from '@/components/Home/InsureCareTeams/QuotesWidget.vue';
import BrokerQuotesWidget from '@/components/Home/InsureCareTeams/BrokerQuotesWidget.vue';
import BrokerClientsWidget from '@/components/Home/InsureCareTeams/BrokerClientsWidget.vue';
import AccountWidget from '@/components/Home/InsureCareTeams/AccountWidget.vue';
import PayBillWidget from '@/components/Home/InsureCareTeams/PayBillWidget.vue';
import Auth from '@/services/Auth';
import { mapGetters } from 'vuex';

@Component({
	name: 'ICTHome',
	components: {
		Welcome,
		CoiWidget,
		ClaimWidget,
		QuotesWidget,
		AccountWidget,
		PayBillWidget,
		BrokerQuotesWidget,
		BrokerClientsWidget,
	},
})
export default class ICTHome extends Vue {
	@Getter('activePolicies', { namespace: 'Policy' }) private policies;
	private Auth: any;

	constructor() {
		super();
		this.Auth = Auth;
	}
}
